<radio [(ngModel)]="value" value="1" name="radioDisabledDemo">radio 1</radio>
<radio [(ngModel)]="value" value="2" name="radioDisabledDemo">radio 2</radio>
<radio [(ngModel)]="value" value="3" name="radioDisabledDemo" disabled>radio 3</radio>
<radio [(ngModel)]="value" value="4" name="radioDisabledDemo" disabled>radio 4</radio>